import type { Calendar } from 'owa-calendar-cache';
import { action } from 'satcheljs';

export const removeCalendar = action('REMOVE_CALENDAR', (calendar: Calendar) => ({ calendar }));
